import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e2305ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "module-progress-bar" }
const _hoisted_2 = {
  class: "progress",
  ref: "progressBar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "progress-bar",
        role: "progressbar",
        style: _normalizeStyle({ width: _ctx.progress + '%' }),
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, null, 4),
      _createElementVNode("div", {
        class: "circle",
        ref: "progressIndicator",
        style: _normalizeStyle({ left: _ctx.progressIndicatorOffset + 'px'})
      }, null, 4)
    ], 512),
    _createElementVNode("div", null, _toDisplayString(_ctx.progress) + "%", 1)
  ]))
}